import { createContext } from 'react';

const WizardContext = createContext();

export default WizardContext;
